import React, { useCallback, useState } from "react";
import TextInput from "./TextInput";
import SelectInput from "./SelectInput";
import { GlobalStyles } from "@arcteryx/components-typography";
import { Header } from "./Header";
import { SubmitBtn } from "./SubmitBtn";
import TextAreaInput from "./TextAreaInput";
import { useForm } from "react-hook-form";
import { getPage } from "../helpers/formHelpers";
import { Success } from "./Success";
import { SALESFORCE_API_URL } from "../constants";
import { Styles } from "../styles/Styles";

export const Inquiry = () => {
  const page = getPage(__PAGE_SETTINGS__.pages);
  const formProperties = page.i18n.form;
  const { name } = page;
  const { successHeader, successDescription } = formProperties;

  const [validInputs, setValidInputs] = useState(
    Object.values(formProperties).reduce((prev, curr) => {
      const { id } = curr;
      return { ...prev, [id]: false };
    }, {})
  );
  const [isSubmitted, setIsSubmitted] = useState(false);

  let heading, description;
  if (formProperties.heading && formProperties.description) {
    heading = formProperties.heading[language];
    description = formProperties.description[language];
  }

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    mode: "onBlur"
  });

  const buildFormInputs = useCallback(
    () =>
      Object.values(formProperties).map(item => {
        if (item.type === "select") {
          return (
            <SelectInput
              key={item.id}
              id={item.id}
              placeHolder={item.list.placeHolderText}
              label={item[language]}
              options={item.list.options}
              register={register}
              errors={errors}
              required={item.required}
              requiredMsg={item.requiredMsg}
              validInputs={validInputs}
              setValidInputs={setValidInputs}
            />
          );
        } else if (item.type === "text") {
          return (
            <TextInput
              key={item.id}
              id={item.id}
              label={item[language]}
              required={item.required}
              register={register}
              errors={errors}
              validInputs={validInputs}
              setValidInputs={setValidInputs}
              requiredMsg={item.requiredMsg}
            />
          );
        } else if (item.type === "textarea") {
          return (
            <TextAreaInput
              key={item.id}
              id={item.id}
              label={item[language]}
              required={item.required}
              register={register}
              errors={errors}
              validInputs={validInputs}
              setValidInputs={setValidInputs}
            />
          );
        }
        return null;
      }),
    [errors, validInputs, setValidInputs, register, formProperties]
  );

  const onSubmit = useCallback(
    async data => {
      formProperties.requiredValues.forEach(x => (data[x.id] = x.value));
      try {
        await fetch(SALESFORCE_API_URL, {
          method: "POST",
          body: JSON.stringify(data)
        });
        setIsSubmitted(true);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
    [formProperties.requiredValues]
  );

  return (
    <>
      <GlobalStyles />
      <Styles />

      {!isSubmitted ? (
        <form className="customer-form" onSubmit={handleSubmit(onSubmit)}>
          {heading && <Header heading={heading} description={description} />}
          {buildFormInputs()}
          <SubmitBtn text={formProperties.submit[language]} />
        </form>
      ) : (
        <Success
          type={name}
          header={
            name === "PRO UNIFORM INQUIRY" ? successHeader[language] : null
          }
          description={successDescription[language]}
        />
      )}
    </>
  );
};

export default Inquiry;
